import { postCreateGameFreespin } from '../api/postCreateGameFreespin';

const setPostCreateGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateGameFreespin(params);
            alert('Игра добавлена')
        } catch(error) {
            alert('Ошибка добавления')
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateGameFreespin
}